import type { UserProfile } from '../../core/model/search';
import { readJson, remove, storageKey, writeJson } from './storage';

const KEY = storageKey('session');

export interface StoredSession {
  readonly accessToken: string;
  readonly user: UserProfile | null;
}

export function loadSession(): StoredSession | null {
  const stored = readJson<StoredSession>(KEY);
  return stored?.accessToken ? stored : null;
}

export function saveSession(session: StoredSession): void {
  writeJson(KEY, session);
}

export function clearSession(): void {
  remove(KEY);
}
